export default __webpack_public_path__ + "static/media/atividade-mao-na-massa.818bdf87.pdf";